import { Controller } from "@hotwired/stimulus"

// Turns a label wrapping a file input into the kit's dropzone: files can be
// dragged onto it, and once one is chosen its name replaces the prompt so the
// administrator can see what they picked before saving.
export default class extends Controller {
  static targets = ["input", "prompt", "chosen"]

  connect() {
    this.depth = 0
  }

  over(event) {
    event.preventDefault()
    this.depth++
    this.element.classList.add("is-dragging")
  }

  leave() {
    this.depth = Math.max(0, this.depth - 1)
    if (this.depth === 0) this.element.classList.remove("is-dragging")
  }

  drop(event) {
    event.preventDefault()
    this.depth = 0
    this.element.classList.remove("is-dragging")

    const files = event.dataTransfer?.files
    if (!files?.length) return

    this.inputTarget.files = files
    this.show()
  }

  show() {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    this.chosenTarget.textContent = `${file.name} (${this.size(file.size)})`
    this.chosenTarget.hidden = false
    this.promptTarget.hidden = true
  }

  size(bytes) {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`
  }
}
